export const getTopicDetails = (store) => store.subtopics.topicDetails;

export const getSubtopicLoader = (store) => store.subtopics.isLoading;
